const data = {
  "shoppingCart": {
    "fact": "Winkelwagen",
    "slogan": "Productenpolonaise.",
    "delivery": "Bezorging",
    "actions": {
      "order": "Bestellen",
      "editCart": "Wijzig winkelwagen",
      "viewCart": "Bekijk je winkelwagen"
    },
    "loadingDropdownContent": "Winkelwageninhoud wordt geladen"
  },
  "prices": {
    "pricePerMonth": "{{price}} per maand",
    "priceExcludingVat": "{{price}} excl. btw",
    "worth": "t.w.v. {{price}}",
    "freeOfCharge": "Gratis meegeleverd",
    "totalAmount": "Totaalbedrag",
    "totalAmountExcludingVat": "Totaalbedrag excl. btw",
    "includedVat": "BTW inbegrepen"
  },
  "labels": {
    "free": "Gratis",
    "cashRegisterDiscount": "Kassakorting",
    "secondChance": "Tweedekans",
    "subscription": "Abonnement",
    "once": "eenmalig"
  },
  "emptyCart": {
    "description": "Tot op de bodem uitgezocht door Gerrit.",
    "imageAltText": "Leeg winkelwagen"
  },
  "addToCart": {
    "added": "Toegevoegd",
    "addedToYourShoppingCart": "Toegevoegd aan je winkelwagen"
  },
  "miniShoppingCart": {
    "totalAmount": "Totaalbedrag",
    "subtotal": "Subtotaal",
    "alreadyPaid": "Al betaald",
    "toBePaid": "Nog te betalen",
    "alreadyPaidWith": "Al betaald met {{provider}}",
    "toBePaidWith": "Nog te betalen met {{provider}}",
    "excludingVat": "Exclusief btw",
    "includingVat": "Inclusief btw",
    "vat": "btw",
    "delivery": "Bezorging",
    "personalDiscount": "Personeelskorting",
    "credits": "Tegoeden",
    "giftCard": "Cadeaukaart",
    "ecocheques": "Ecocheques",
    "ecochequeProduct": "Ecocheque product",
    "secondChance": "Tweedekans",
    "secondChanceEcochequeProduct": "Tweedekans ecocheque product",
    "showAllProducts": "Toon alle producten",
    "showLessProducts": "Toon minder producten",
    "pricePerMonth": "<price></price> per maand",
    "priceExcludingVat": "<price></price> excl. btw"
  }
};

export default data;